(function () {
  angular
   .module('kareo.ui.shared.directives.validation.k-valid-password', [
     'kareo.ui.shared.modules.api.user.k-user-service'
   ])
   .directive('kValidPassword', kValidPassword);

  const defaults = {
    updateOn: 'blur',
    updateOnDefault: true,
    debounce: {
      'default': 300,
      'blur': 0
    }
  };

  kValidPassword.$inject = ['kUserService', '$q'];

  function kValidPassword(kUserService, $q) {
    return {
      bindToController: {
        allow: '<?kValidPassword'
      },
      controller() {},
      controllerAs: 'kVP',
      restrict: 'A',
      require: 'ngModel',
      link(scope, element, atts, ngModel) {
        ngModel.$options = angular.merge({}, defaults, ngModel.$options);
        ngModel.$asyncValidators.validPassword = validPassword;
        ngModel.errorMessages = [];

        function validPassword(modelValue) {
          if (modelValue === scope.kVP.allow ||
                ngModel.$isEmpty(modelValue)) {
            return $q.when(true);
          }

          return kUserService
            .validateUserPassword(modelValue)
            .then((response) => {
              ngModel.errorMessages = [];
              return response;
            }, (errorMessages) => {
              ngModel.errorMessages = errorMessages;
              return $q.reject(errorMessages);
            });
        }
      }
    };
  }
})();
